import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { pick, get, find } from 'lodash';

import MakePurchase from '../../components/make-purchase';
import Loading from '../../../components/loading';
import Purchase from '../../lib/purchase';
import {
  getCurrentPurchase,
  getMemberships,
  getOrganizerMembership,
} from '../../selectors/purchase-selector';
import {
  getCurrentUser,
} from '../../selectors/user-selector';

import {
  fetchPurchase,
  projectPurchase,
  fetchPurchaseMemberships,
  submitPayment,
  hideRemoveModal,
  showPaymentSentModal,
  SHARED_NAMESPACE,
} from '../../actions/index';

class MakePurchaseContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      redirectTo: false,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onCloseRemoveModalClick = this.onCloseRemoveModalClick.bind(this);
    this.onClosePaymentSentClick = this.onClosePaymentSentClick.bind(this);
  }

  componentWillMount() {
    const { id: purchaseId } = this.props.purchase;
    this.props.actions.fetchPurchaseMemberships(purchaseId, this.props.purchase.memberships.length)
      .then(() => {
        const purchase = pick(this.props.purchase, ['id', 'group']);
        purchase.memberships = [];
        return this.props.actions.projectPurchase(purchase, SHARED_NAMESPACE);
      });
  }

  componentWillReceiveProps(newProps) {
    const slug = this.props.match.params.id;
    if (newProps.purchase && !this.canMakePurchase(newProps.purchase)) {
      window.location = `/purchases/${slug}`;
    }
  }

  onCloseRemoveModalClick() {
    this.props.actions.hideRemoveModal();
  }

  onClosePaymentSentClick() {
    const { purchase: { slug } } = this.props;
    this.setState({ redirectTo: `/purchases/${slug}` });
  }

  onSubmit(props) {
    const { purchase: { currentPayment = {} }, authentication } = this.props;
    this.startSubmitting();
    this.props.actions.submitPayment(currentPayment.id, authentication)
      .then(() => {
        this.stopSubmitting();
        this.props.actions.showPaymentSentModal();
      })
      .catch(() => {
        alert('Error submitting payment');
        this.stopSubmitting();
      });
  }

  get submitting() {
    return this.state.submitting;
  }

  canMakePurchase(purchase) {
    const {invitees} = this.props;
    const {status, currentPayment, tipped} = purchase;

    if (!Purchase.isActive(status)) return false;
    if (!currentPayment) return false;
    if (!tipped) return false;

    const hasInvalidInvitee = !!find(invitees, i => i.failed || i.short);

    if (hasInvalidInvitee) return false;
    return true;
  }

  redirect() {
    window.location = this.state.redirectTo;
    return null;
  }

  startSubmitting() {
    this.setState({ submitting: true });
  }

  stopSubmitting() {
    this.setState({ submitting: false });
  }

  render() {
    if (this.state.redirectTo) return this.redirect();
    if (this.props.isLoading) return <Loading />;

    return (
      <MakePurchase
        user={this.props.user}
        authentication={this.props.authentication}
        purchase={this.props.purchase}
        projectedPurchase={this.props.projectedPurchase}
        invitees={this.props.invitees}
        organizerMembership={this.props.organizerMembership}
        onSubmit={this.onSubmit}
        submitting={this.submitting}
        onCloseRemoveModalClick={this.onCloseRemoveModalClick}
        onClosePaymentSentClick={this.onClosePaymentSentClick}
        isRemoveModalVisible={this.props.isRemoveModalVisible}
        isPaymentSentModalVisible={this.props.isPaymentSentModalVisible}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({
      fetchPurchase,
      projectPurchase,
      fetchPurchaseMemberships,
      submitPayment,
      hideRemoveModal,
      showPaymentSentModal,
    }, dispatch),
  };
};

const mapStateToProps = (state) => {
  const memberships = getMemberships(state);
  const purchase = getCurrentPurchase(state);
  const projectedPurchase = get(state.projections, `${SHARED_NAMESPACE}.purchase`);

  return {
    purchase,
    projectedPurchase,
    user: getCurrentUser(state),
    isLoading: !projectedPurchase,
    authentication: state.session.authentication,
    invitees: memberships,
    organizerMembership: getOrganizerMembership(state),
    isRemoveModalVisible: state.ui.modals.remove,
    isPaymentSentModalVisible: state.ui.modals.paymentSent,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MakePurchaseContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/make-purchase/index.container.js